// frontend/src/pages/AssessmentCompletionPage.tsx
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const AssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const { assessmentId } = useParams<{ assessmentId: string }>();

  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <div className="text-center">
        <div className="mb-8">
          <CheckCircle className="w-24 h-24 text-green-400 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white mb-2">Assessment Completed!</h1>
          <p className="text-gray-300 text-lg">
            Thank you for completing the assessment. Your responses have been submitted successfully.
          </p>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 mb-8">
          <h2 className="text-xl font-semibold text-white mb-4">What happens next?</h2>
          <div className="space-y-3 text-left">
            <div className="flex items-start">
              <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
              <p className="text-gray-300">
                Your responses are being analyzed by our AI system to evaluate your skills
              </p>
            </div>
            <div className="flex items-start">
              <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
              <p className="text-gray-300">
                Results and feedback will be available to your administrators for review
              </p>
            </div>
            <div className="flex items-start">
              <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
              <p className="text-gray-300">
                You can take additional assessments to further validate your skills
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/assessments')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-md font-medium transition-colors duration-200"
          >
            View More Assessments
          </button>
          
          <button
            onClick={() => navigate('/role-selection')}
            className="w-full bg-gray-600 hover:bg-gray-700 text-white py-3 px-6 rounded-md font-medium transition-colors duration-200"
          >
            Update Role Preferences
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-md font-medium transition-colors duration-200"
          >
            Back to Dashboard
          </button>
        </div>


      </div>
    </div>
  );
};

export default AssessmentCompletionPage;
